// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 777 ? "recorder" : chunkId) + "." + {"777":"0fd5256fe2ad8cca0371","913":"348d1e7323a487481c32"}[chunkId] + ".js";
};